import { useMemo, useState } from "react";
import "./transaction.css";
import CardCustom from "../../components/card";
import { TableCustomProps } from "../../components/table/table";
import { LottiesComponent } from "../../components/loadingLotties/LottiesComponent";
import cardLottie from "../../assets/lottie/target.json";
import TableMaterial from "../../components/tableMaterial/tableMaterial";
import ModalUI from "../../components/modalUI/ModalUI";
import { TransactionModal } from "./transactionModal/TransactionModal";
import ButtonUI from "../../components/button/buttons";
import { PaymentIcon } from "react-svg-credit-card-payment-icons";
import HelpIcon from "@mui/icons-material/Help";
import useFetchTransactionsByUser from "../../service/userTransactions/getTransaction";
import { formatToMexicanPesos } from "../../utils/format";

const Transaction = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endStarDate, setEndStartDate] = useState<Date | null>(null);
  const [selectedTransaction, setSelectTransaction] = useState<null>(null);

  const [openModal, setOpenModal] = useState(false);
  const [email, setEmail] = useState<string>("");
  const [searchClicked, setSearchClicked] = useState(false);
  const [status, setStatus] = useState("ALL");

  const handleOpenModal = (transaction: any) => {
    setOpenModal(true);
    setSelectTransaction(transaction);
  };

  const transformDataToTable = (
    transactions: any[]
  ): TableCustomProps["rows"] => {
    const translations: { [key: string]: string } = {
      APPROVED: "Aprobado",
      failed: "Rechazado",
      DECLINED: "Rechazado",
      PENDING: "Pendiente",
      FAILED: "Rechazado",
      charge_pending: "Pendiente",
      CHARGE_PENDING: "Pendiente",
      EXPIRED: "Expirado",
      expired: "Expirado",
      completed: "Completado",
      COMPLETED: "Completado",
    };

    const translateStatus = (status: string): string => {
      return translations[status] || status;
    };

    return transactions.map((transaction) => ({
      user: transaction.profile?.email,
      name: transaction?.full_name,
      company: (
        <PaymentIcon
          type={transaction.card_brand}
          format="flatRounded"
          width={36}
        />
      ),
      activity: transaction.status_description,
      email: transaction.email,
      beforeamount: formatToMexicanPesos(transaction?.balance_before ?? 0), 
      amount: formatToMexicanPesos(transaction?.amount),
      comision: transaction?.comission
        ? formatToMexicanPesos(
            transaction?.comission?.api_commission?.commission
          )
        : formatToMexicanPesos(transaction?.amount_with_comision),
      date: new Date(transaction?.created_at).toLocaleDateString("es-MX", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZone: "America/Mexico_City",
      }),
      status: (
        <div className={`status ${transaction?.status?.toLowerCase()}`}>
          {translateStatus(transaction?.status)}
        </div>
      ),
      info: (
        <div>
          <ButtonUI
            icon={<HelpIcon />}
            variant="text"
            onClick={() => handleOpenModal(transaction)}
          />
        </div>
      ),
    }));
  };

  const { transactions, loading, refetch } = useFetchTransactionsByUser(
    page,
    rowsPerPage,
    {
      email: email || undefined,
      status: status || undefined,
      dateFrom: startDate ? startDate.toISOString() : undefined,
      dateTo: endStarDate ? endStarDate.toISOString() : undefined,
    }
  );

  const dataTable: any = {
    columns: [
      { id: "user", label: "Email de Usuario" },
      { id: "name", label: "Nombre de tarjeta" },
      { id: "company", label: "Banco" },
      { id: "activity", label: "Respuesta de banco" },
      { id: "email", label: "Email de tarjeta" },
      { id: "amount", label: "Pago" },
      { id: "comision", label: "Comisión" },
      { id: "date", label: "Fecha" },
      { id: "status", label: "Estado" },
      { id: "info", label: "Info" },
    ],
    rows: transformDataToTable(transactions?.response?.data || []),
  };

  const onChangeEmail = (e: any) => {
    setEmail(e.target.value);
  };

  const handleSearchClick = () => {
    setSearchClicked((prev) => !prev);
    refetch();
  };

  const onClickCleanFilters = () => {
    setEndStartDate(null);
    setStartDate(null);
    setStatus("ALL");
    setEmail("");
  };

  return (
    <div>
      <CardCustom classCustom="activity_card">
        <h2>Transacciones</h2>
        <TableMaterial
          id="table-reportes"
          isClean={true}
          setStatus={setStatus}
          status={status}
          onClickFilters={onClickCleanFilters}
          valueInput={email}
          onClickSearch={handleSearchClick}
          onChangeInput={onChangeEmail}
          isDate={true}
          setEndDate={setEndStartDate}
          setStartDate={setStartDate}
          startDate={startDate}
          endDate={endStarDate}
          totalRows={transactions?.response?.pagination?.countData}
          setPage={setPage}
          page={page}
          setRowsPerPage={setRowsPerPage}
          rowsPerPage={rowsPerPage}
          report={true}
          columns={dataTable.columns}
          rows={dataTable?.rows || []}
          loading={loading}
          isSearch={true}
        />
      </CardCustom>
      <ModalUI
        title="Información de transacción"
        open={openModal}
        setOpen={setOpenModal}
      >
        <TransactionModal data={selectedTransaction || []} />
      </ModalUI>
    </div>
  );
};

export default Transaction;